import Button, { ButtonTypes } from "../Button";
import { Footer } from "./styles";
import { CardFooterLinkProps } from "./types";

export const CardFooterLink: React.FC<CardFooterLinkProps> = ({
  children,
  isMobileOnly = false,
  ...buttonProps
}) => (
  <Footer $isMobileOnly={isMobileOnly}>
    <Button type={ButtonTypes.link} isFullWidth {...buttonProps}>
      {children}
    </Button>
  </Footer>
);
